import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useApi } from '../../../hooks/useApi'
import { Proposal } from '../../../types/api/Proposal'
import { LoadingSpinner } from '../../../globalComponents/LoadingSpinner'

export const ProposalPage = () => {

    const {quoteId} = useParams()
    const api = useApi();
    const [proposal, setProposal] = useState<Proposal | null>(null)
    const [proposalMissing, setProposalMissing] = useState(false)
    const [loading, setLoading] = useState(true)
    
    useEffect( () => {
        if(!quoteId) return
        (async () => {
            const proposal = await api.proposal.find({quoteId})
            setLoading(false)
            if(!proposal){
                setProposalMissing(true)
                return 
            }
            setProposal(proposal)
        })()
        
    },[])

    return (
        <div className='relative flex flex-1 flex-col w-full'>
            {loading
                ? <div className='flex h-full items-center justify-center'><LoadingSpinner/></div>
                : proposalMissing
                    ? <p>No proposal has been created for this quote.</p>
                    : <iframe name="test" className='flex-1' src={proposal?.pdfDataUrl}/>
            }
            
        </div>
    )
}